
import React from 'react';
import { Image } from '@themesberg/react-bootstrap';

// import ReactLogo from "../assets/img/technologies/react-logo-transparent.svg";

export default (props) => {

  const { show } = props;

  return (
    <div className={`preloader flex-column justify-content-center align-items-center ${show ? "" : "show"}`}>
      <Image className="loader-element" src="/Logo IUD 2025 animado.gif" height={80} />
    </div>
  );
};
